export default {
  name: 'landing',
  data: function() {
    return {
      id: '',
      senseID: '',
      linkAddress: 'groheondus://guard/installation/finished/'
    }
  },
  computed: {
    landingText: function() {
      return this.$store.getters.langFile[this.$options.name]
    },
    legal: function() {
      return this.$store.getters.langFile.legal
    }
  },
  methods: {
    routeToOverview: function() {
      let id = this.$route.params.id
      if (typeof id === 'undefined') {
        id = 'en_GB'
      }
      this.$router.push({
        name: 'overview',
        params: {
          id
        }
      })
    },
    routeToPlan: function() {
      let id = this.$route.params.id
      this.$store.commit('changeName', 'entry-component')
      this.$store.commit('changeColor', true)
      this.$router.push({
        name: 'plan',
        params: {
          id
        }
      })
    },
    routeToInstallerPlan: function() {
      let id = this.$route.params.id
      this.$store.commit('changeName', 'nineth-component')
      this.$store.commit('changeColor', false)
      this.$store.commit('changeConnectNow', false)
      this.$router.push({
        name: 'plan',
        params: {
          id
        }
      })
    },
    routeToInterlude: function() {
      let id = this.$route.params.id
      if (typeof id === 'undefined') {
        id = 'en_GB'
      }
      this.$router.push({
        name: 'interlude',
        params: {
          id
        }
      })
    },
    goToImprint: function() {
      let id = this.$route.params.id
      this.$router.push({
        name: 'imprint',
        params: {
          id
        }
      })
    }
  },
  beforeMount: function() {
    this.$route.params.id = this.$route.params.id == null ? 'en_GB' : this.$route.params.id
    // CERCLOUD-1092_AC8
    if (screen.width < 900) {
      this.routeToPlan()
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/landing/landing.js